module.exports = __webpack_public_path__ + "static/media/s_big_04.79a53a00.png";